import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-test-instruction-dialog',
  templateUrl: './test-instruction-dialog.component.html',
  styleUrls: ['./test-instruction-dialog.component.css']
})
export class TestInstructionDialogComponent implements OnInit {

  counterAnimation: boolean = true;
  firstScreen: boolean = true;
  secondScreen: boolean = false;

  constructor(private router: Router, public dialog: MatDialog, public dialogRef: MatDialogRef<TestInstructionDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

    setTimeout(() => { 
      this.counterAnimation = false;
      this.dialogRef.close(true);
    }, 4000);
    
  }

  
  startTest(){
    this.firstScreen = false;
    this.secondScreen = true;
    setTimeout(() => {
      this.dialogRef.close(true);
      this.router.navigate([`selfLearn-V2/practice-questions`]);
    }, 4000);
  }

}
